import { IsNotEmpty, IsObject, IsOptional, IsString } from 'class-validator';

export class UserPermissionDto {
  @IsString()
  @IsNotEmpty()
  resource!: string;

  @IsString()
  @IsNotEmpty()
  action!: string;

  @IsOptional()
  @IsObject()
  conditions?: Record<string, unknown>; // Optional: ownerOnly, orgId, etc.
}
